import { Box, DialogContent } from '@material-ui/core';
//import { StyledDialog } from '@room-match/shared-ui-components'; // Remove CloseIcon and StyledDialog
import CloseIcon from '../Icon/CloseIcon'; // Use talent app level folder CloseIcon - Jerome
import StyledDialog from 'shared/elements/StyledDialog/StyledDialog';
import React from 'react';
import { ImageCarousel } from '../ImageCarousel';
import { useStyles } from './ImageGallery.styles';

type Props = {
  open: boolean;
  onClose: () => void;
  images: any;
  thumbnails: any;
  current?: number;
  fullScreen?: boolean;
};

const ImageGallery: React.FC<Props> = ({ open, onClose, images, thumbnails, current, fullScreen }) => {
  const classes = useStyles();
  return (
    <StyledDialog
      fullWidth
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      BackdropProps={{ style: { backgroundColor: '#000000', opacity: 0.9 } }}
      style={{ maxHeight: fullScreen ? '100%' : '95%', margin: fullScreen ? 10 : 10 }}
    >
      <DialogContent className={classes.dialogStyle}>
        <Box className={classes.header}>
          <div onClick={onClose} style={{ zIndex: 99, cursor: 'pointer' }}>
            <CloseIcon fontSize="small" />
          </div>
        </Box>
        <Box className={classes.imageContainer}>
          <ImageCarousel images={images} thumbnails={thumbnails} current={current} />
        </Box>
      </DialogContent>
    </StyledDialog>
  );
};

export default ImageGallery;
